import Market from '@/creditflowresearch/domain/Market/Market';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import { MarketName, MarketAbbreviations } from '@/creditflowresearch/domain/Market/types/MarketType';
import { CORPORATE_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import { APAC_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class ApacMarket extends Market {
  static readonly MARKET_ID: string = APAC_MARKET_ID;

  static readonly NAME: MarketName = MarketName.APAC_MARKET;

  static readonly ABBREVIATION: MarketAbbreviations = MarketAbbreviations.APAC_MARKET;

  isVisible(): boolean {
    return false;
  }

  isBeta(): boolean {
    return false;
  }

  getSegments(): Segment[] {
    return CORPORATE_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  protected getRegionIdForMarket(): string | null {
    return Region.APAC_ID;
  }
}

export default ApacMarket;
